import React from 'react'
import { ReactComponent } from './Maps.svg'
import { MergeReactElementProps } from '../types'

interface MapsProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', MapsProps>

export const Maps = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
